import { Navigate, Outlet } from "react-router";
import { SCORE_TYPE, useFoodpilotContext, VIEW } from "src/context/FoodpilotContext";

export const ScoresProtection = () => {
    const { canUser } = useFoodpilotContext();

    if (!canUser(VIEW, SCORE_TYPE)) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
